var installedModules = {};
var moduleToHandlerMapping = {
	8236: {
		getter: () => (__webpack_require__.e(7404).then(() => (() => (__webpack_require__(7404))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	2194: {
		getter: () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(316))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	3300: {
		getter: () => (__webpack_require__.e(8771).then(() => (() => (__webpack_require__(1152))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "9.2.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngneat/helipopper",
	},
	984: {
		getter: () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(4791))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/animations",
	},
	6156: {
		getter: () => (__webpack_require__.e(2075).then(() => (() => (__webpack_require__(4456))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	5120: {
		getter: () => (__webpack_require__.e(8471).then(() => (() => (__webpack_require__(852))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "15.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-translate/core",
	},
	9649: {
		getter: () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(6443))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	6207: {
		getter: () => (__webpack_require__.e(6768).then(() => (() => (__webpack_require__(6768))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@pflm-shared",
	},
	1108: {
		getter: () => (__webpack_require__.e(1398).then(() => (() => (__webpack_require__(1398))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.14",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/cdk",
	},
	6470: {
		getter: () => (__webpack_require__.e(5315).then(() => (() => (__webpack_require__(7696))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	9140: {
		getter: () => (__webpack_require__.e(4604).then(() => (() => (__webpack_require__(2223))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "13.9.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ng-select/ng-select",
	},
	7715: {
		getter: () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(436))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.13",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	1937: {
		getter: () => (__webpack_require__.e(6383).then(() => (() => (__webpack_require__(6383))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "markdown-to-text",
	},
	7386: {
		getter: () => (__webpack_require__.e(920).then(() => (() => (__webpack_require__(920))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	8934: {
		getter: () => (__webpack_require__.e(5485).then(() => (() => (__webpack_require__(5485))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "19.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	8025: {
		getter: () => (__webpack_require__.e(7254).then(() => (() => (__webpack_require__(4873))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query-persist-client",
	},
	9237: {
		getter: () => (__webpack_require__.e(9745).then(() => (() => (__webpack_require__(9745))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "6.13.7",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "mobx",
	},
	9019: {
		getter: () => (__webpack_require__.e(1347).then(() => (() => (__webpack_require__(3728))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.85.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@tanstack/react-query",
	},
	3115: {
		getter: () => (__webpack_require__.e(8952).then(() => (() => (__webpack_require__(8952))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.0.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@ngx-translate/http-loader",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"316": [
		8236
	],
	"429": [
		6156,
		7715
	],
	"436": [
		2194,
		8236,
		9649
	],
	"647": [
		8236,
		2194,
		6207,
		6156,
		9140,
		6470,
		984,
		5120,
		9649,
		1108
	],
	"754": [
		6156
	],
	"852": [
		8236
	],
	"893": [
		984,
		1108,
		2194,
		5120,
		6207,
		6470,
		8236,
		9649
	],
	"1049": [
		984,
		1108,
		2194,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"1118": [
		8236,
		7715,
		6470,
		6207,
		2194,
		984,
		6156,
		9649,
		3115,
		5120,
		1108
	],
	"1152": [
		2194,
		8236
	],
	"2047": [
		8236,
		2194,
		6207,
		6470,
		5120,
		9649,
		1108,
		984,
		6156
	],
	"2223": [
		2194,
		6156,
		8236
	],
	"2686": [
		984,
		1108,
		2194,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"2700": [
		984,
		1108,
		2194,
		5120,
		6156,
		6207,
		6470,
		7715,
		8236,
		9140,
		9649
	],
	"2790": [
		984,
		1108,
		2194,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"3009": [
		984,
		1108,
		2194,
		3300,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"3162": [
		7386,
		8934,
		9237
	],
	"3549": [
		6156
	],
	"3573": [
		7715
	],
	"3728": [
		7386
	],
	"3772": [
		8236,
		6470,
		2194,
		6156,
		5120,
		9649,
		6207,
		1108,
		984,
		9140,
		7715
	],
	"3774": [
		984,
		1108,
		2194,
		3300,
		5120,
		6156,
		6207,
		6470,
		7386,
		8236,
		8934,
		9649
	],
	"3892": [
		2194,
		8236,
		984,
		6156,
		6207
	],
	"4034": [
		984,
		2194,
		6156,
		6207,
		7386,
		8236,
		8934
	],
	"4075": [
		984,
		1108,
		1937,
		2194,
		3300,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"4278": [
		8236,
		2194,
		6207,
		6156,
		5120,
		9649,
		1108,
		984,
		6470,
		9140
	],
	"4387": [
		7386,
		8025,
		9237
	],
	"4456": [
		2194,
		8236
	],
	"4713": [
		984,
		1108,
		2194,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"4873": [
		7386,
		9019
	],
	"5110": [
		2194,
		8236
	],
	"5315": [
		7715
	],
	"5546": [
		7386,
		8934
	],
	"5744": [
		9019
	],
	"6167": [
		8236,
		2194,
		6470,
		6156,
		5120,
		9649,
		6207,
		1108,
		984
	],
	"6186": [
		6156,
		7715
	],
	"6255": [
		7715
	],
	"6442": [
		8236,
		2194,
		5120,
		9649,
		6207,
		1108,
		984,
		6470,
		3300,
		6156,
		7386,
		8934
	],
	"6443": [
		2194,
		8236
	],
	"6728": [
		984,
		1108,
		2194,
		5120,
		6207,
		6470,
		8236,
		9649
	],
	"6768": [
		7386,
		8025,
		9237
	],
	"6784": [
		8236,
		5120,
		9649,
		6207,
		2194,
		1108,
		984,
		6470,
		3300,
		6156
	],
	"7108": [
		8236,
		2194,
		3300,
		984,
		6156,
		5120,
		9649,
		6207,
		1108,
		6470,
		9140
	],
	"7172": [
		2194,
		8236
	],
	"7254": [
		9019
	],
	"7650": [
		984,
		1108,
		2194,
		3300,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	],
	"7666": [
		8236,
		5120,
		9649,
		6207,
		2194,
		1108,
		984,
		6470,
		3300,
		1937,
		6156,
		9140
	],
	"7696": [
		2194,
		7715,
		8236
	],
	"7866": [
		7386
	],
	"7978": [
		8236,
		2194,
		6156,
		5120,
		9649,
		6207,
		1108,
		984,
		6470,
		3300,
		1937,
		9140
	],
	"8055": [
		9649
	],
	"8259": [
		8236,
		2194,
		6156,
		5120,
		9649,
		6207,
		1108,
		984,
		6470
	],
	"8708": [
		984,
		1108,
		2194,
		5120,
		6156,
		6207,
		6470,
		8236,
		9649
	],
	"9017": [
		8236
	],
	"9229": [
		984,
		1108,
		2194,
		3300,
		5120,
		6156,
		6207,
		6470,
		8236,
		9649
	],
	"9893": [
		984,
		1108,
		1937,
		2194,
		3300,
		5120,
		6156,
		6207,
		6470,
		8236,
		9140,
		9649
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}